import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import {
  ChangeElementTypologyDialog,
  FormSubmitButtons,
  GridWrap,
  InfoWrapper,
  RHFSelect,
  RHFTagAutocomplete,
} from 'components';
import { tipologiaControventoOptions } from 'constants/selectOptions';
import { INFO } from 'pages/Inspections/config/info';
import { resetObjectSchedaIspezione } from 'utils/Inspections/L1/resetSchedaIspezione';
import useSchedaDifetti from 'utils/Inspections/L1/schedeDifetti';
import { isNullOrUndefinedOrEmptyString } from 'utils/utilities';

const ControventiForm = ({
  controventiFields,
  selected,
  setSelected,
  controventiTable,
  selectedIdx,
}) => {
  const { getValues, setValue } = useFormContext({
    defaultValues: {
      controventiTableValue: [],
      tipologiaControventoTableValue: '',
    },
  });

  const { populateSchedaDifetti } = useSchedaDifetti();

  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);

  useEffect(() => {
    setValue('controventiTableValue', selected);
  }, [selected]);

  useEffect(() => {
    onResetControventi();
  }, [selectedIdx]);

  const changeAutocomplete = value => {
    setSelected(value);
  };

  const changeControventi = () => {
    const tipologiaControventoTableValue = getValues(
      'tipologiaControventoTableValue'
    );

    const ids = selected.map(el => el.codice);

    const controventi = [...controventiFields];

    controventi.map((x, index) => {
      if (ids.includes(x?.codice)) {
        controventi[index] = {
          ...x,
          tipologiaControvento: tipologiaControventoTableValue,
          ...(tipologiaControventoTableValue !== x.tipologiaControvento
            ? {
                ...resetObjectSchedaIspezione,
                schedaDifetti: populateSchedaDifetti(
                  'controvento',
                  tipologiaControventoTableValue
                ).map(el => {
                  return {
                    ...el,
                    visto: false,
                    statoDifetto: '',
                    estensioneDifetto: '',
                    intensitaDifetto: '',
                    ps: false,
                    note: '',
                    media: [],
                  };
                }),
              }
            : null),
        };
      }
    });

    setValue(controventiTable, controventi);
    onResetControventi();
  };

  const onConfirmChangeControventi = () => {
    setOpenConfirmationDialog(false);
    changeControventi();
  };

  const onSubmitControventi = () => {
    const tipologiaControventoTableValue = getValues(
      'tipologiaControventoTableValue'
    );

    const ids = selected.map(el => el.codice);

    const controventi = [...controventiFields];

    const hasChangedTipologia = controventi.some(el => {
      if (ids.includes(el?.codice)) {
        return (
          tipologiaControventoTableValue !== el.tipologiaControvento &&
          !isNullOrUndefinedOrEmptyString(el.tipologiaControvento)
        );
      }
    });

    if (hasChangedTipologia) {
      setOpenConfirmationDialog(true);
    } else {
      changeControventi();
    }
  };

  const onResetControventi = () => {
    setValue('controventiTableValue', []);
    setValue('tipologiaControventoTableValue', '');
    setSelected([]);
  };

  return (
    <>
      <GridWrap container spacing={2} mt={2}>
        <InfoWrapper
          size={3}
          infoMessage={INFO.controventiSelezionati.infoMessage}
        >
          <RHFTagAutocomplete
            multiple={true}
            id="tags-controventi"
            name={'controventiTableValue'}
            changeAutocomplete={value => {
              changeAutocomplete(value);
            }}
            labelName={'option.codice'}
            getOptionLabel={option => option.codice}
            opt={controventiFields?.filter(
              el => !selected?.some(s => s?.id === el?.id)
            )}
            label="Controventi selezionati"
          />
        </InfoWrapper>
        <GridWrap item xs={3}>
          <RHFSelect
            name="tipologiaControventoTableValue"
            label="Tipologia Controvento"
            defaultValue={''}
            onChange={e => {
              setValue('tipologiaControventoTableValue', e.target.value);
            }}
            selectOptions={tipologiaControventoOptions}
          />
        </GridWrap>
        <GridWrap item xs={6} alignSelf="center">
          <FormSubmitButtons
            onSubmit={onSubmitControventi}
            onReset={onResetControventi}
          />
        </GridWrap>
      </GridWrap>
      <ChangeElementTypologyDialog
        open={openConfirmationDialog}
        onClose={() => setOpenConfirmationDialog(false)}
        onConfirm={onConfirmChangeControventi}
      />
    </>
  );
};
ControventiForm.propTypes = {
  controventiFields: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      codice: PropTypes.string,
      tipologiaControvento: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
      ]),
    })
  ),
  selected: PropTypes.array,
  setSelected: PropTypes.func,
  controventiTable: PropTypes.string,
  selectedIdx: PropTypes.number,
};

export default ControventiForm;
